import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Dialog extends Vue {
    //显示
    @Prop({
        type: Boolean,
        default: false
    })
    public visible!: boolean;

    //弹窗显示
    public set dialog_visible(val: boolean) {
        this.$emit('update:visible', val);
    }

    public get dialog_visible(): boolean {
        return this.visible;
    }

    public loading: boolean = false;
}